<ng-template #loading>
   <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>

<ng-template #noresults>
   <div class="no-results">No Matching Reports</div>
</ng-template>

<ng-container *ngIf="list | async else loading">
   <div class="common-pad1em report-list">
      <div class="flex">
         <lib-status-legend [selected]="reportStatus" (clicked)="toggle_shared_key( $event )"></lib-status-legend>

         <div class="common-mb1em">
            <button id="report-new" mat-raised-button color="primary" routerLink="/report/new">
               <mat-icon>add</mat-icon> NEW
            </button>
         </div>
      </div>

      <ng-container *ngIf="dataSource.filteredData.length else noresults">
         <ng-container *ngIf="[ 'name', 'owner_name', 'last_updated', 'actions' ] as columns">
            <mat-table [dataSource]="dataSource" class="rotate-cdk-table" matSort>
               <ng-container matColumnDef="name">
                  <mat-header-cell #sortHeader *matHeaderCellDef mat-sort-header class="common-fg3">Report Name</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="report-name common-fg3">
                     <div class="header">Report Name</div>
                     <div class="cell disembodied">
                        <ng-container *ngIf="SharedKeysMap( row ) as status_key">
                           <button [id]="'report-status-button-' + row.id" mat-button (click)="toggle_shared_key( status_key )" [style.left.px]=" !breakpoints.large ? -16 : null" matTooltip="Click to filter by this status">
                              <span class="status" [ngClass]="status_key"></span>
                              <span *ngIf="!breakpoints.large"  class="common-ml2ex"> {{SharedKeysEnum[status_key]}}</span>
                           </button>
                        </ng-container>

                        <button [id]="'report-bookmark-button-' + row.id" mat-button (click)="row.pinned ? unpin( row.id ) : pin( row.id )" matTooltip="Bookmark" [disabled]="row.id == pinning">
                           <ng-container *ngIf="row.id != pinning else spinner">
                              <mat-icon>{{row.pinned ? 'bookmark' : 'bookmark_border'}}</mat-icon>
                              <span *ngIf="!breakpoints.large" class="common-ml2ex">{{row.pinned ? 'Bookmarked' : 'Bookmark'}}</span>
                           </ng-container>
                           <ng-template #spinner>
                              <mat-spinner diameter="24"></mat-spinner>
                           </ng-template>
                        </button>
                     </div>
                     <div class="cell">
                        <ng-container *ngIf="!row.owned else link">{{row.name}}</ng-container>
                        <ng-template #link>
                           <a [id]="'report-view-button-' + row.id" routerLink="/report/edit/{{row.id}}" class="common-tdnone">{{row.name}}</a>
                        </ng-template>
                     </div>
                  </mat-cell>
               </ng-container>

               <ng-container matColumnDef="owner_name">
                  <mat-header-cell #sortHeader *matHeaderCellDef mat-sort-header>Owner</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                     <div class="header">Owner</div>
                     <div class="cell">
                        <a [id]="'report-owner_name-filter-' + row.id" class="common-tdnone common-pointer" (click)="dataSource.filter = ( dataSource.filter == row.owner_name ) ? '' : row.owner_name">{{row.owner_name}}</a>
                     </div>
                  </mat-cell>
               </ng-container>

               <ng-container matColumnDef="last_updated">
                  <mat-header-cell #sortHeader *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                     <div class="header">Last Updated</div>
                     <div class="cell">{{row.last_updated | date}}</div>
                  </mat-cell>
               </ng-container>

               <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef class="list-headercell">Actions</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="list-cell">
                     <div class="header">Actions</div>
                     <div class="cell">
                        <button [id]="'report-schedule-button-' + row.id"  mat-icon-button *ngIf="!breakpoints.small && row.owned && row.is_scheduled" routerLink="/report/schedule/{{row.id}}">
                           <mat-icon>timer</mat-icon>
                        </button>
                        <button [id]="'report-run-button-' + row.id" mat-button *ngIf="!breakpoints.small" class="run-report" routerLink="/report/run/{{row.id}}">
                           <mat-icon class="common-mr1ex">timeline</mat-icon>
                           Run Report
                        </button>

                        <button [id]="'report-action-button-' + row.id" mat-icon-button [matMenuTriggerFor]="actions">
                           <mat-icon>more_vert</mat-icon>
                        </button>

                        <mat-menu #actions="matMenu" class="float-menu" xPosition="before" yPosition="below" overlapTrigger="false">
                           <button [id]="'report-action-run-button-' + row.id" mat-menu-item *ngIf="breakpoints.small" routerLink="/report/run/{{row.id}}">
                              <mat-icon>timeline</mat-icon> Run Report
                           </button>
                           <button [id]="'report-action-edit-button-' + row.id" mat-menu-item *ngIf="row.owned" routerLink="/report/edit/{{row.id}}">
                              <mat-icon>edit</mat-icon> Edit
                           </button>
                           <button [id]="'report-action-schedule-button-' + row.id" mat-menu-item *ngIf="breakpoints.small && row.owned && row.is_scheduled" routerLink="/report/schedule/{{row.id}}">
                              <mat-icon>timer</mat-icon> Schedules
                           </button>
                           <button [id]="'report-action-copy-button-' + row.id" mat-menu-item routerLink="/report/copy/{{row.id}}">
                              <mat-icon>filter_none</mat-icon> Copy
                           </button>
                           <button [id]="'report-action-export-button-' + row.id" mat-menu-item *ngIf="false">
                              <mat-icon>get_app</mat-icon> Export
                           </button>
                           <button [id]="'report-action-delete-button-' + row.id" mat-menu-item *ngIf="row.owned" (click)="deleting = row">
                              <mat-icon>delete</mat-icon> Delete
                           </button>
                        </mat-menu>
                     </div>
                  </mat-cell>
               </ng-container>

               <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
               <mat-row *matRowDef="let row; columns: columns"></mat-row>
            </mat-table>
         </ng-container>
      </ng-container>

      <div #deleteConfirm class="delete-confirm" *ngIf="_deleting">
         <div color="warn" class="common-mb1em" *ngIf="_deleting.shared">
            Warning! This report is shared and other users will lose access to it!
         </div>
         <div class="delete-confirm-actions">
            <div class="common-mr1em">Are you sure you want to delete this report?</div>
            <button id="report-delete-confirm-button" mat-raised-button color="warn" (click)="delete( _deleting )">Delete</button>
            <button id="report-delete-cancel-button" mat-button (click)="deleting = null">Cancel</button>
         </div>
      </div>

      <mat-paginator
         *ngIf="!_deleting"
         [pageSize]="pageSize"
         [pageSizeOptions]="[5, 10, 25, 100]"
         (page)="pageSize = $event.pageSize">
      </mat-paginator>
   </div>
</ng-container>
